import { Link } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/js/dist/collapse'
import 'bootstrap/js/dist/offcanvas'
import 'bootstrap/js/dist/dropdown'

function MenuInicial() {
    return (
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
        <div className="container-fluid">
          <Link className="navbar-brand" to="/">
            <img src="./logo.png" alt="logo" width={50} height={40}/>
            <span> Marcadores de Deportes </span>
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav ms-auto">
              
              <li className="nav-item" >
                <Link className="nav-link" to="/PageLogin">
                  Login
                </Link>
              </li>
              <li className="nav-item" >
                <Link className="nav-link" to="/PageRegistro">
                  Registro
                </Link>
              </li>
              
            </ul>
          </div>
        </div>
      </nav>
    );
}

export default MenuInicial;